<script lang="ts">
  import { onMount } from "svelte"
  import { toast, xhr } from "$app/utils"
  import Loading from "$app/components/Loading.svelte"
  import Tiptap from "$app/components/Tiptap.svelte"
  import { onlyTextButtons } from "$app/components/Tiptap/buttons"
  import { appStore } from "$app/store.svelte"

  interface Props {
    flywheel: FlywheelType
    onupdate: (data: FlywheelType) => void
  }

  let props = $props()
  let { flywheel, onupdate }: Props = props

  let saving = $state(false)
  let form = { ...flywheel }
  let errors: any = $state({})

  async function updateFlywheel(): Promise<void | boolean> {
    saving = true

    try {
      let url = `/plans/${appStore.plan.id}/flywheel/${flywheel.id}.json`

      const resp = await xhr.put(url, {
        flywheel: {
          title: form.title,
          description: form.description
        }
      })

      onupdate(resp.data)
    } catch (e) {
      toast(`There was an error updating`, "error")
      if (e.response && e.response.data) {
        errors = e.response.data.errors
      }
    } finally {
      saving = false
    }
  }

  function focusInput(): void {
    const input = document.querySelector(
      "input[name=flywheel-title]"
    ) as HTMLInputElement
    if (input) {
      input.focus()
    }
  }

  onMount(() => {
    focusInput()
  })
</script>

<div class="flex items-center px-4 py-4 sm:px-6">
  <div
    class="flex-1 px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
  >
    <div>
      <input
        type="text"
        bind:value={form.title}
        class:error={errors.title}
        placeholder="Flywheel Central Theme"
        name="flywheel-title"
        class="input block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
      />
      {#if errors.title}
        <div class="msg">{errors.title}</div>
      {/if}
    </div>
    <div class="text-left mt-4 w-full inline-block">
      <div class="mt-1">
        <Tiptap
          content={flywheel.description}
          onupdate={(data) => (form.description = data.html)}
          placeholder={`Enter a description (optional)`}
          class="h-16"
          id="statement_description"
          buttons={onlyTextButtons}
        />
      </div>
    </div>

    <div class="flex mt-6 justify-end">
      <Loading loading={saving}>
        <button
          class="btn btn-primary ml-2"
          disabled={saving}
          onclick={() => {
            updateFlywheel()
          }}
          data-name="button-save"
        >
          {#if flywheel.enabled}
            Update Flywheel Theme
          {:else}
            Create Flywheel
          {/if}
        </button>
      </Loading>
    </div>
  </div>
</div>
